import React from "react";
import {form, Loader} from "@mc/mc-legacy";
import {Button} from "reactstrap";

const FormBody = form.FormBody;
const FormActions = form.FormActions;

class SubmitOnlyForm extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {onClose, handleSubmit, submitting, message, submitText} = this.props;
        return (
            <div>
                <FormBody>
                    <p className={'mx-auto text-center'}>{message}</p>
                    {submitting && <p>
                        <Loader />
                        Vyčkejte prosím...
                    </p>
                    }
                </FormBody>
                <FormActions onClose={onClose} disabled={submitting} submitButton={false}>
                    <Button
                        className={"ml-2"}
                        color={"primary"}
                        type={"submit"}
                        disabled={submitting}
                        onClick={handleSubmit}
                    >
                        {submitText}
                    </Button>
                </FormActions>
            </div>
        );
    }
}
export default SubmitOnlyForm;
